import { AbstractDestroyable, LogConfiguration, Logger, Revive } from '@deqo/foundation';
import produce, { enableMapSet } from 'immer';
import { decorate, injectable } from 'inversify';
import React from 'react';
import ReactDOM from 'react-dom';
import slugify from 'slugify';
import './@css/index.css';
import { telemetry } from './@vendor/Posthog';
import { Host } from './Host';
import { App } from './app/App';
import { KioskApp } from './app/KioskApp';
import { ServerDate } from './platform/ServerDate';
import { UserAgent } from './platform/UserAgent';
import * as serviceWorker from './serviceWorker';

// c):)
ServerDate.sync();

// >:~@
enableMapSet();
Revive.produce = produce;

// :^)
decorate(injectable(), AbstractDestroyable);

// :-O
document.body.classList.add(
    'deqo',
    slugify(UserAgent.browser.name.toLowerCase()),
    slugify(`${UserAgent.browser.name.toLowerCase()}-${UserAgent.browser.version}`),
);

// ;-)
window.addEventListener('wheel', e => {
    if (e.ctrlKey) e.preventDefault();
}, { passive: false });

// >:)
telemetry.init();

// d:D
const urlParams = new URLSearchParams(window.location.search);
const useLogger = (key: string, enabled: boolean, color: string): LogConfiguration => ({
    [key]: [Boolean(urlParams.get(key) ?? enabled), color]
});
Logger.configure({
    ...useLogger('app.telemetry', Host.env === 'local', 'SlateBlue'),
    ...useLogger('app.api', false, 'Navy'),
    ...useLogger('app.hangout', false, 'Brown'),
    ...useLogger('app.metrics', false, 'DarkGreen'),
    ...useLogger('app.objects', false, 'Purple'),
    ...useLogger('app.events', Host.env === 'local', 'Chocolate'),
    ...useLogger('app.errors', true, 'Red'),
    ...useLogger('podopolis.model', false, 'MediumVioletRed'),
    ...useLogger('podopolis.connection', false, 'MediumVioletRed'),
    ...useLogger('podopolis.session', false, 'MediumVioletRed'),
    ...useLogger('podopolis.stats', false, 'DarkGreen'),
});

const container = document.getElementById('app');
ReactDOM.render(Host.kiosk ? <KioskApp /> : <App />, container);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// }
